export const Roles = {
    ROLE_1: {id: 1, text: 'Superadmin', value: 'role1'},
    ROLE_2: {id: 2, text: 'Admin', value: 'role2'},
    ROLE_3: {id: 3, text: 'Contractor', value: 'role3'},

    list() {
        return [
            this.ROLE_1,
            this.ROLE_2,
            this.ROLE_3
        ]
    }
}
